import React from 'react';

const searchResultHeaderCity = (props) => (
    <span className={`u-fontSize16 u-phone-fontSize13 u-fontWeightMedium`}>{props.children}</span>
);

export default searchResultHeaderCity;


// WEBPACK FOOTER //
// ./src/components/UI/Headers/SearchResultHeader/SearchResultHeaderCity/SearchResultHeaderCity.js